<div echarts [options]="chartOption$ | async" class="full-height full-width"></div>
